import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarDokterParuDetailAdmin from "../../components/TopBarDokterParuDetailAdmin";
import ProfileDokterParuAdmin from "../../components/ProfileDokterParuAdmin";
import "../../CSS/ProfileTenagaKesehatan.css";

function HalamanProfileDokterParu() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarDokterParuDetailAdmin />

        {/* Konten utama */}
        <div className="main-contentprofile">
          <ProfileDokterParuAdmin />
        </div>

        
      </div>
    </div>
  );
}

export default HalamanProfileDokterParu;
